import { GradeSelect, SubjectSelect } from 'src/components/common'
import { Select } from 'src/components/select'
import Search from 'src/components/search'

const Filters = ({
  buttonComponent = {},
  filter = {
    subject_id: null,
    grade_id: null,
    status: null,
    period: null,
    query: '',
  },
  status = {
    options: [{ value: '', label: 'All' }],
  },
  hidePeriod = false,
  period = {
    options: [
      { value: '', label: 'All' },
      { value: 'day', label: 'This day' },
      { value: 'week', label: 'This week' },
      { value: 'month', label: 'This month' },
    ],
  },
  setFilter = () => {},
}) => (
  <>
    <div className="row">
      <div className="col-lg-9 col-md-6 col-sm-6">
        <div className="searchHb searchHb-middle">
          <div className="input-block ">
            <Search
              onChange={(value) => {
                setFilter({ ...filter, query: value })
              }}
            />
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="input-block">{buttonComponent}</div>
      </div>
    </div>

    <div className="row">
      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="input-block">
          <SubjectSelect
            value={filter.subject_id}
            onChange={(item) => {
              setFilter({ ...filter, subject_id: item?.value })
            }}
          />
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="input-block">
          <GradeSelect
            value={filter.grade_id}
            onChange={(item) => {
              setFilter({ ...filter, grade_id: item?.value })
            }}
          />
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="input-block">
          <Select
            placeholder="Status"
            value={filter.status}
            onChange={(item) => {
              setFilter({ ...filter, status: item?.value })
            }}
            options={status.options}
          />
        </div>
      </div>
      {!hidePeriod && (
        <div className="col-lg-3 col-md-6 col-sm-6">
          <div className="input-block">
            <Select
              black
              placeholder="Period"
              value={filter.period}
              onChange={(item) => {
                setFilter({ ...filter, period: item?.value })
              }}
              options={period.options}
            />
          </div>
        </div>
      )}
    </div>
  </>
)

export default Filters
